<template>
  <div class="relative p-7 grid grid-rows-6 gap-y-4">
    <div
      id="header"
      class="row-span-1 grid grid-cols-12 gap-x-6"
    >
      <div
        id="photo"
        class="col-span-4 flex justify-center"
      >
        <profile-picture
          v-if="((personnal || {}).profile_image || {}).isDisplayed"
          id="photo"
          size="max-w-36 w-36 h-36"
          :supports-object-fit="false"
          :is-circle-avatar="false"
          :specific-url="((personnal || {}).profile_image || {}).value || null"
          :with-border="false"
        />
      </div>
      <div
        id="header-plus"
        :class="
          'col-span-8 flex flex-col space-y-2 items-center justify-center px-5 ' +
            colorBgLight
        "
      >
        <div
          class="text-left text-xl"
          v-if="personnal.prenom.isDisplayed || personnal.nom.isDisplayed"
        >
          <span v-if="personnal.prenom.isDisplayed">
            {{ personnal.prenom.value }}
          </span>
          <span v-if="personnal.nom.isDisplayed">
            {{ personnal.nom.value }}
          </span>
        </div>

        <div :class="'text-base-2 ' + colorText">
          {{ name }}
        </div>
        <div class="text-2sm text-center">
          {{ description }}
        </div>
      </div>
    </div>
    <div class="row-span-5 grid grid-cols-12 gap-x-6">
      <div
        id="side"
        :class="
          'relative col-span-4 ' +
            colorBgLight +
            ' pl-7 pr-9 py-6 flex flex-col space-y-4 h-full'
        "
      >
        <div
          v-if="
            (personnal.adresse.value &&
              personnal.adresse.isDisplayed &&
              personnal.adresse.value != '') ||
              (personnal.date_naissance.value &&
                personnal.date_naissance.isDisplayed &&
                personnal.date_naissance.value != '') ||
              (personnal.email.value &&
                personnal.email.isDisplayed &&
                personnal.email.value != '') ||
              (personnal.telephone.value &&
                personnal.telephone.isDisplayed &&
                personnal.telephone.value != '') ||
              (personnal.site_web.value &&
                personnal.site_web.isDisplayed &&
                personnal.site_web.value != '') ||
              (personnal.linkedin.value &&
                personnal.linkedin.isDisplayed &&
                personnal.linkedin.value != '')
          "
          id="contact"
          class="flex flex-col space-y-1.5"
        >
          <div
            :class="
              'uppercase text-base-2 font-semibold ' + colorText + ' text-left'
            "
          >
            Contact
          </div>
          <div class="border-t border-gray-900 w-10" />
          <div
            id="date_naissance"
            v-if="
              personnal.date_naissance.value &&
                personnal.date_naissance.isDisplayed &&
                personnal.date_naissance.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Date de naissance
            </p>
            <p class="text-2sm text-gray-600">
              {{
                new Date(
                  personnal.date_naissance.value
                ).toLocaleDateString()
              }}
            </p>
          </div>
          <div
            id="adresse"
            v-if="
              personnal.adresse.value &&
                personnal.adresse.isDisplayed &&
                personnal.adresse.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Adresse
            </p>
            <p class="text-2sm text-gray-600">
              {{ personnal.adresse.value }}
            </p>
          </div>
          <div
            id="email"
            v-if="
              personnal.email.value &&
                personnal.email.isDisplayed &&
                personnal.email.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Email
            </p>
            <p class="text-2sm text-gray-600">
              {{ personnal.email.value }}
            </p>
          </div>
          <div
            id="telephone"
            v-if="
              personnal.telephone.value &&
                personnal.telephone.isDisplayed &&
                personnal.telephone.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Téléphone
            </p>
            <p class="text-2sm text-gray-600">
              {{ personnal.telephone.value }}
            </p>
          </div>
          <div
            id="siteweb"
            v-if="
              personnal.site_web.value &&
                personnal.site_web.isDisplayed &&
                personnal.site_web.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Site internet
            </p>
            <a
              :href="'https://' + personnal.site_web.value"
              class="text-2sm text-gray-600"
            >
              {{ personnal.site_web.value }}
            </a>
          </div>
          <div
            id="linkedin"
            v-if="
              personnal.linkedin.value &&
                personnal.linkedin.isDisplayed &&
                personnal.linkedin.value != ''
            "
          >
            <p class="text-2sm font-semibold text-gray-900">
              Linkedin
            </p>
            <a
              :href="'https://' + personnal.linkedin.value"
              class="text-2sm text-indigo-600 italic underline"
            >
              {{ personnal.linkedin.value }}
            </a>
          </div>
        </div>
        <div
          id="permis"
          class="flex flex-col space-y-1.5"
          v-if="
            (personnal.permis_conduire.isDisplayed &&
              personnal.permis_conduire.value.filter((p) => p != 'Autres')
                .length > 0) ||
              (personnal.moyen_transport.isDisplayed &&
                personnal.moyen_transport.value.filter(
                  (m) => !['Autres', 'Aucun'].includes(m)
                ).length > 0)
          "
        >
          <div
            :class="
              'uppercase text-base-2 font-semibold ' + colorText + ' text-left'
            "
          >
            Permis
          </div>
          <div class="border-t border-gray-900 w-10" />

          <div
            v-if="
              personnal.permis_conduire.isDisplayed &&
                personnal.permis_conduire.value.filter((p) => p != 'Autres')
                  .length > 0
            "
            class="flex flex-col space-y-1.5"
          >
            <p class="text-2sm font-semibold text-gray-900">
              <span
                v-for="(permis, kp) in personnal.permis_conduire.value.filter(
                  (p) => p != 'Autres'
                )"
                :key="kp"
              >
                {{ permis
                }}<span
                  v-if="
                    kp <
                      personnal.permis_conduire.value.filter((p) => p != 'Autres')
                        .length -
                      1
                  "
                >,
                </span>
              </span>
            </p>
          </div>

          <div
            id="moyens_transport"
            v-if="
              personnal.moyen_transport.isDisplayed &&
                personnal.moyen_transport.value.filter(
                  (m) => !['Autres', 'Aucun'].includes(m)
                ).length > 0
            "
            class="flex flex-col space-y-1.5"
          >
            <p class="text-2sm font-semibold text-gray-900">
              Moyen de déplacement
            </p>
            <p class="text-2sm text-gray-600">
              <span
                v-for="(
                  transport, kt
                ) in personnal.moyen_transport.value.filter(
                  (m) => !['Autres', 'Aucun'].includes(m)
                )"
                :key="kt"
              >
                {{ transport
                }}<span
                  v-if="
                    kt <
                      personnal.moyen_transport.value.filter(
                        (m) => !['Autres', 'Aucun'].includes(m)
                      ).length -
                      1
                  "
                >,
                </span>
              </span>
            </p>
          </div>
        </div>
        <div
          id="infos"
          class="flex flex-col space-y-1.5"
          v-if="personnal.travailleur_handicape.value"
        >
          <div
            :class="
              'uppercase text-base-2 font-semibold ' + colorText + ' text-left'
            "
          >
            Informations personnelles
          </div>
          <div class="border-t border-gray-900 w-10" />
          <p class="text-2sm font-semibold text-gray-900">
            Reconnaissance en tant que travailleur handicapé
          </p>
        </div>
        <div
          v-if="langues.filter((l) => l.isDisplayed).length > 0"
          id="langues"
          class="flex flex-col space-y-1.5"
        >
          <div
            :class="
              'uppercase text-base-2 font-semibold ' + colorText + ' text-left'
            "
          >
            Langues
          </div>
          <div class="border-t border-gray-900 w-10" />
          <p
            v-for="(langue, kl) in langues.filter((l) => l.isDisplayed)"
            :key="kl"
            class="text-2sm"
          >
            <span class="font-semibold text-gray-900">
              {{ langue.value.name }} :
            </span>
            <span class="text-gray-600">
              {{ niveaux[langue.value.niveau] }}
            </span>
          </p>
        </div>
        <div
          v-if="hobbies.filter((h) => h.isDisplayed).length > 0"
          id="interets"
          class="flex flex-col space-y-1.5"
        >
          <div
            :class="
              'uppercase text-base-2 font-semibold ' + colorText + ' text-left'
            "
          >
            Centres d'intérêt
          </div>
          <div class="border-t border-gray-900 w-10" />
          <div class="flex flex-wrap">
            <p
              v-for="(hobbie, kh) in hobbies.filter((h) => h.isDisplayed)"
              :key="kh"
              class="text-2sm font-semibold text-gray-900"
            >
              <span class="mx-1">{{ kh > 0 ? '-' : '' }}</span>{{ hobbie.value }}
            </p>
          </div>
        </div>
      </div>
      <div
        id="content"
        class="col-span-8 flex flex-col space-y-6"
      >
        <div
          v-if="pros.filter((p) => p.isDisplayed).length > 0"
          id="xp"
          class="flex flex-col space-y-1.5"
        >
          <div :class="'text-base-2 ' + colorText + ' font-semibold uppercase'">
            Expériences
          </div>
          <div class="border-t border-gray-900 w-10" />
          <div class="mt-4 flex flex-col space-y-3.5">
            <div
              v-for="(pro, pi) in pros.filter((p) => p.isDisplayed)"
              :key="pi"
              class="grid grid-cols-12 gap-x-2.5"
            >
              <div
                class="col-span-3 uppercase text-2sm font-semibold"
              >
                {{ formatDatesWithSeparator(pro, true) }}
              </div>
              <div class="col-span-9 flex flex-col space-y-1.5">
                <div class="text-2sm font-semibold text-gray-900">
                  {{ pro.value.value.intitule_parcours }}
                </div>
                <div class="text-2sm text-gray-600">
                  {{ pro.value.value.structure_accueil_parcours }}
                </div>
                <div class="text-2xs text-gray-600 whitespace-pre-line">
                  {{ pro.value.value.aborde_parcours }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="formations.filter((f) => f.isDisplayed).length > 0"
          id="formations"
          class="flex flex-col space-y-1.5"
        >
          <div :class="'text-base-2 ' + colorText + ' font-semibold uppercase'">
            Formations
          </div>
          <div class="border-t border-gray-900 w-10" />
          <div class="mt-4 flex flex-col space-y-3.5">
            <div
              v-for="(formation, i) in formations.filter((f) => f.isDisplayed)"
              :key="i"
              class="grid grid-cols-12 gap-x-2.5"
            >
              <div
                class="col-span-3 uppercase text-2sm font-semibold"
              >
                {{ formatDatesWithSeparator(formation) }}
              </div>
              <div class="col-span-9 flex flex-col space-y-1.5">
                <div class="text-2sm font-semibold text-gray-900">
                  {{ formation.value.value.intitule_parcours }}
                </div>
                <div class="text-2sm text-gray-600">
                  {{ formation.value.value.localisation_parcours }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="listCompetences.length > 0"
          id="competences"
          class="flex flex-col space-y-1.5"
        >
          <div :class="'text-base-2 ' + colorText + ' font-semibold uppercase'">
            Compétences
          </div>
          <div class="border-t border-gray-900 w-10" />
          <div class="grid grid-cols-2 gap-x-5 gap-y-1">
            <div
              v-for="comp in listCompetences"
              :key="comp.value + 'basic2'"
              class="text-gray-600 col-span-1 text-2sm"
            >
              {{ comp.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!watermarkHidden" id="footer" class="mb-2 absolute w-full bottom-0 left-0 text-right pr-3 text-sm font-semibold text-gray-600">CV créé à partir de l'application Neopass</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProfilePicture from './../../../components/ProfilePicture.vue';
import { formatDatesWithSeparator } from './formatDates';

export default {
  methods: { formatDatesWithSeparator },
  components: {
    ProfilePicture,
  },

  props: {
    color: {
      type: String,
      required: false,
      default: 'teal',
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    personnal: Object,
    formations: Array,
    pros: Array,
    competences: Object,
    langues: Array,
    hobbies: Array,
  },

  data() {
    return {
      niveaux: ['Débutant', 'Intermédiaire', 'Courant', 'Avancé', 'Bilingue'],
    };
  },

  computed: {
    ...mapGetters({
      backdoor: 'app/backdoor',
      watermarkHidden: 'curriculumVitae/watermarkHidden',
    }),

    colorBgLight() {
      switch (this.color) {
      case 'yellow':
        return 'bg-yellow-100';
      case 'pink':
        return 'bg-pink-100';
      case 'teal':
        return 'bg-teal-100';
      case 'orange':
        return 'bg-orange-100';
      case 'gray':
        return 'bg-gray-200';

      default:
        return 'bg-teal-100';
      }
    },
    colorBgNormal() {
      switch (this.color) {
      case 'yellow':
        return 'bg-yellow-600';
      case 'pink':
        return 'bg-pink-600';
      case 'teal':
        return 'bg-teal-600';
      case 'orange':
        return 'bg-orange-600';
      case 'gray':
        return 'bg-gray-600';

      default:
        return 'bg-teal-600';
      }
    },
    colorText() {
      switch (this.color) {
      case 'yellow':
        return 'text-yellow-600';
      case 'pink':
        return 'text-pink-600';
      case 'teal':
        return 'text-teal-600';
      case 'orange':
        return 'text-orange-600';
      case 'gray':
        return 'text-gray-600';

      default:
        return 'text-teal-600';
      }
    },
    listCompetences() {
      this.backdoor; //for reactivity

      return [...new Set(Object.values(this.competences).flat())].filter(
        (cmp) => cmp.isDisplayed
      );
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Times New Roman', Times, serif;
}

h1 {
  font-size: 64px;
  text-align: center;
}
h2 {
  font-size: 48px;
  text-align: center;
}
h3 {
  font-size: 32px;
  text-align: center;
}
h4 {
  font-size: 28px;
  text-align: center;
}
h5 {
  font-size: 24px;
  text-align: center;
}
h6 {
  font-size: 21.3px;
  text-align: center;
}

.text-2xs {
  font-size: 10.7px;
}
.text-2sm {
  font-size: 12px;
}
.text-sm {
  font-size: 14.5px;
}
.text-base {
  font-size: 17.3px;
}
.text-base-2 {
  font-size: 18.7px;
}
.text-lg {
  font-size: 21.3px;
}
.text-xl {
  font-size: 24px;
}
.text-2xl {
  font-size: 28px;
}
.text-3xl {
  font-size: 32px;
}
.text-3\.5xl {
  font-size: 37.3px;
}
.text-4xl {
  font-size: 48px;
}
.text-5xl {
  font-size: 64px;
}
.text-plusButton {
  font-size: 41.3px;
}

#side {
  height: 885px;
}
</style>